// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CommunicationController from "./communication_controller"
application.register("communication", CommunicationController)

import FrameLoaderController from "./frame_loader_controller"
application.register("frame-loader", FrameLoaderController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import StreamScriptController from "./stream_script_controller"
application.register("stream-script", StreamScriptController)

import AccordeonController from "./accordeon_controller"
application.register("accordeon", AccordeonController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)
